/* Canonical rise-time maths for the /pages/dough-rise widget.
   VERBATIM from sections/calculators-suite.liquid:
     calculateFermentationTime() (~line 1599) and lftPhysics() (~line 2245).
   Do not edit the formulas without re-running scripts/verify-rise-maths.mjs. */
(function (root) {
  function yeasted(yeastPct, tempC) {
    var bulk = (12 * (0.2 / yeastPct)) / Math.pow(2, (tempC - 20) / 10);
    bulk = Math.max(0.5, bulk);
    var proof = Math.max(0.5, bulk * (tempC > 24 ? 0.20 : 0.25));
    return { bulk: bulk, proof: proof };
  }
  // Compact widget fixes flour='bread' (1.0) and hyd=75 (1.0) and omits the main calc's
  // optional starter-vigor / cold-retard adjustments, so this is lftPhysics() reduced to
  // its temperature + inoculation terms, plus the main calc's +/-25% spread.
  function sourdough(inocPct, tempC) {
    var hours = 4.5 * Math.pow(20 / inocPct, 0.7) * Math.pow(2, (25 - tempC) / 10);
    return { hours: hours, low: hours * 0.75, high: hours * 1.25 };
  }
  var DRRise = { yeasted: yeasted, sourdough: sourdough };
  if (typeof module !== 'undefined' && module.exports) module.exports = { DRRise: DRRise };
  root.DRRise = DRRise;
})(typeof window !== 'undefined' ? window : globalThis);
